/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name permissionrequired
 * @description If the user doesn't have the required permission for the current company, remove this element
 * @attr {String} permissionrequired Comma seperatd list of permissions required to view this element
 */
angular.module('mercury.directives.permissionrequired', [])
.directive('permissionrequired', ["userinfo", function(userinfo) {
  return {
    restrict: 'A',
    compile: function(scope, attrs) {
      return {
        pre: function(scope, element) {
          if (!userinfo.companyHasPermission(attrs.permissionrequired)) {
            element.remove();
          }
        }
      };
    }
  };
}]);
